import { faPieChart } from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';

import UserChallengeAnswers from '@/components/UserChallengeAnswers';
import useAPI from '@/hooks/useAPI';
import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import UserChallengeRepository from '@/repositories/UserChallengeRepository';
import Accordion from '@/ui/components/Accordion/Accordion';
import Spinner from '@/ui/components/Spinner';

const UserChallengeEvent = ({ activityLog }: TimelineSubcomponentProps) => {
  const { actor, data: activityLogData, object_id, timestamp } = activityLog;
  const challengeRepository = UserChallengeRepository();

  const {
    data: challenge,
    isPending,
    refetch: getChallenge
  } = useAPI({
    queryKey: ['getChallenge', [object_id]],
    queryFn: async () => {
      return await challengeRepository.get({ id: object_id });
    },
    enabled: false
  });

  return (
    <div>
      <div className="mb-2">
        <Accordion
          buttonText={
            <TimelineHeader
              icon={faPieChart}
              iconClassName="text-purple-500"
              subtitle={activityLogData?.challenge?.challenge?.title}
              title="Challenge Submission"
            />
          }
          onClick={getChallenge}>
          {isPending ? (
            <Spinner />
          ) : challenge ? (
            <UserChallengeAnswers answers={challenge.data?.answers ?? ''} />
          ) : (
            <div>Unable to retrieve challenge data</div>
          )}
        </Accordion>
      </div>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(UserChallengeEvent);
